//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Header from '@/modules/partner/components/sama-el-baraka/header.vue';
import Footer from '@/modules/partner/components/sama-el-baraka/footer.vue';
import i18n from '@/vueI18n';
import { setPageMeta } from '@/shared/utils/meta-tags';
import { SAMA_BARAKA_LOGO } from '@/modules/partner/constants/sama-baraka-branding';

export default {
  name: 'sama-el-baraka-return-policy',

  components: {
    [Header.name]: Header,
    [Footer.name]: Footer,
  },

  data() {
    return {
      sections: [
        { key: 'period', type: 'text' },
        { key: 'conditions', type: 'list', items: [0, 1, 2, 3] },
        { key: 'nonReturnable', type: 'list', items: [0, 1] },
        { key: 'warranty', type: 'list', items: [0, 1, 2, 3] },
        { key: 'shipping', type: 'list', items: [0, 1] },
        { key: 'refund', type: 'text' },
      ],
    };
  },

  computed: {
    language() {
      return i18n.locale;
    },
  },

  watch: {
    language() {
      this.updateMeta();
    },
  },

  mounted() {
    this.updateMeta();
    window.scrollTo(0, 0);
  },

  methods: {
    updateMeta() {
      const lang = this.language || 'ar';
      setPageMeta({
        title: this.$t('samaElBaraka.returnPolicy.ogTitle'),
        description: this.$t('samaElBaraka.returnPolicy.ogDescription'),
        url: `https://www.afigr.com/${lang}/sama-baraka/return-policy`,
        image: `https://www.afigr.com${SAMA_BARAKA_LOGO}`,
        locale: lang,
      });
    },
  },
};
